<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const TickIconAlternative = getIcon("TickIconAlternative");
export let className = "";
</script>

{#if typeof TickIconAlternative === 'string'}
	<img src={TickIconAlternative} alt={$t(Verbiage.icon_alt, 'alts')} class={className} />
{:else if typeof TickIconAlternative === 'function'}
	<svelte:component this={TickIconAlternative} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
